var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDeezer = function SvgIconDeezer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.8 15.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8h5.4v3H0zm6.5 0h5.4v3H6.5zm6.5 0h5.3v3H13zm6.4 0h5.4v3h-5.4zM6.5 8.6h5.4v3H6.5zm6.5 0h5.3v3H13zm6.4 0h5.4v3h-5.4zM6.5 4.3h5.4v3H6.5zm12.9 0h5.4v3h-5.4zm0-4.3h5.4v3h-5.4z"
  })));
};
export default SvgIconDeezer;